import React, { useContext, useEffect, useState } from 'react';
import profile from '../dist/webImages/profile2.png';
import camera from '../dist/webImages/camera.svg';
import swal from 'sweetalert';
import FormControl from '../components/form/FormControl';
import { Form, Formik } from 'formik';
import SubmitButton from '../components/SubmitButton';
import { Link, useNavigate, useParams } from 'react-router-dom';
import back from '../dist/webImages/back.svg';
import SkeletonCreateEdit from '../Lawyers/SkeletonCreateEdit';
import useGet from '../customHooks/useGet';
import usePost from '../customHooks/usePost';
import { MainLanguageContext } from '../context/MainLanguageContext';
import { toast } from 'react-toastify';

const EditAuthor = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const { mainLanguage } = useContext(MainLanguageContext);
  const [loading, setLoading] = useState(true);
  const [resget, apiMethodGet] = useGet();

  useEffect(() => {
    if (mainLanguage) {
      setLoading(true);
      apiMethodGet(`authors/singleDetail/${id}/${mainLanguage}`);
    }
  }, [mainLanguage]);

  const [imgValue, setImgValue] = useState('');
  const [imgPath, setImgPath] = useState('');

  useEffect(() => {
    if (resget?.data) {
      setLoading(false);
      const data = resget?.data?.data;
      if (data?.image) setImgPath(data.image);
    }
  }, [resget.isLoading]);

  const handleFileUpload = (e) => {
    const file = e.target.files[0];
    if (file) {
      if (!file?.type?.includes('image')) {
        swal('Only use Image', '', 'warning');
        return;
      }
      if (file.size > 102400) { // 100 KB = 102400 bytes
        swal('Image size must be less than 100 KB', '', 'warning');
        return;
      }
      setImgPath((window.URL || window.webkitURL).createObjectURL(file));
      setImgValue(file);
    }
  };

  const handleDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    if (!file?.type?.includes('image')) {
      swal('Only use Image', '', 'warning');
      return;
    }
    if (file.size > 102400) {
      swal('Image size must be less than 100 KB', '', 'warning');
      return;
    }
    setImgPath((window.URL || window.webkitURL).createObjectURL(file));
    setImgValue(file);
  };

  const [res, apiMethod] = usePost();

  const handleSubmit = (values) => {
    const requiredFields = { en_name: 'Name (EN)', en_designation: 'Designation (EN)', en_bio: 'Bio (EN)' /*, slug: 'URL Slug' */ };
    const missing = [];

    for (const key in requiredFields) {
      if (!values[key]?.trim()) missing.push(requiredFields[key]);
    }
    if (!imgPath) missing.push('Profile Image');

    if (missing.length > 0) {
      swal({
        title: 'Required Fields are empty! Please fill and try again',
        text: missing.join(', '),
        icon: 'error',
        dangerMode: true,
      });
      return;
    }

    const formdata = new FormData();
    // formdata.append('slug', values.slug);
    formdata.append('active', values.active ? 1 : 0);
    if (imgValue) formdata.append('image', imgValue);

    // English translation
    formdata.append('translations[en][lang]', 'en');
    formdata.append('translations[en][fields_value][name]', values.en_name);
    formdata.append('translations[en][fields_value][designation]', values.en_designation);
    formdata.append('translations[en][fields_value][bio]', values.en_bio);

    // Arabic translation
    formdata.append('translations[ar][lang]', 'ar');
    formdata.append('translations[ar][fields_value][name]', values.ar_name);
    formdata.append('translations[ar][fields_value][designation]', values.ar_designation);
    formdata.append('translations[ar][fields_value][bio]', values.ar_bio);

    apiMethod(`authors/${id}`, formdata);
  };

  useEffect(() => {
    if (res.data) {
      const { status, message } = res.data;
      if (status === 'false') {
        toast.error(message);
      } else {
        navigate('/authors');
        toast.success(message);
      }
    }
  }, [res.data]);

  if (resget.isLoading || loading) return <SkeletonCreateEdit heading='Edit Author' />;

  const data = resget?.data?.data;
  const enFields = data?.translations?.en?.fields_value || {};
  const arFields = data?.translations?.ar?.fields_value || {};
  const initialValues = {
    en_name: enFields?.name || '',
    en_designation: enFields?.designation || '',
    en_bio: enFields?.bio || '',
    ar_name: arFields?.name || '',
    ar_designation: arFields?.designation || '',
    ar_bio: arFields?.bio || '',
    // slug: data?.slug || '',
    active: data?.active ?? 1,
  };

  return (
    <div className='createTeam pr-10 max-lg:pr-6'>
      <Link to='/authors' className='back flex items-center mb-5 gap-2'>
        <img src={back} className='w-[2rem]' alt='' />
        <span className='text-[1.4rem] font-MluvkaBold'>Edit Author</span>
      </Link>

      <div className='bg-[#EFF4FD] p-6 rounded-3xl mb-3 max-lg:p-2'>
        <div className='TeamModel transition-all duration-300 bg-white rounded-xl'>
          <div className='overflow-auto modelBox'>
            <Formik initialValues={initialValues} onSubmit={handleSubmit}>
              {({ values, setFieldValue }) => (
                <Form name='editAuthorForm'>
                  <div className='TeamBox p-5 rounded-xl'>

                    {/* Profile Image */}
                    <div className='mb-6'>
                      <label className='mb-2 block text-[#7D8CA7] text-[.9rem] font-MluvkaBold'>Profile Image</label>
                      <div className='w-[6rem] h-[6rem] relative' onDrop={handleDrop} onDragOver={(e) => e.preventDefault()}>
                        <img
                          src={imgPath || profile}
                          className='w-full h-full rounded-3xl object-cover border-2 border-[#C0CCE2]'
                          alt='author'
                        />
                        <div className='TeamBoxinput w-[2rem] h-[2rem] bg-[#C0CCE2] grid place-items-center rounded-full absolute right-[-1rem] top-[-1rem] cursor-pointer z-10'>
                          <input type='file' onChange={handleFileUpload} className='absolute inset-0 opacity-0 cursor-pointer' />
                          <img src={camera} alt='camera' className='cursor-pointer' />
                        </div>
                      </div>
                    </div>

                    {/* Shared Fields */}
                    <div className='mb-4 grid grid-cols-2 gap-4 max-lg:grid-cols-1'>
                      {/* <FormControl
                        name='slug'
                        label='URL Slug'
                        placeholder='Enter URL Slug (e.g. john-doe)'
                        className='outline-none w-full h-[2.7rem] border border-[#CFD5E2] px-5 rounded-full'
                        control='input'
                      /> */}
                      {/* <div className='flex items-center gap-3 mt-5'>
                        <label className='text-[#7D8CA7] text-[.9rem] font-MluvkaBold'>Active</label>
                        <input
                          type='checkbox'
                          checked={!!values.active}
                          onChange={(e) => setFieldValue('active', e.target.checked ? 1 : 0)}
                          className='w-5 h-5 cursor-pointer accent-secondary'
                        />
                      </div> */}
                    </div>

                    {/* Bilingual Fields */}
                    <div className='grid grid-cols-2 gap-6 max-lg:grid-cols-1'>

                      {/* English Fields */}
                      <div className='bg-[#F8FAFF] rounded-2xl p-5 border border-[#E2E8F4]'>
                        <h3 className='text-primary font-MluvkaBold text-[1rem] mb-4 flex items-center gap-2'>
                          <span className='bg-secondary text-white text-xs px-2 py-1 rounded-full'>EN</span>
                          English
                        </h3>
                        <FormControl
                          name='en_name'
                          label='Name'
                          placeholder='Enter author name'
                          className='outline-none w-full h-[2.7rem] border border-[#CFD5E2] px-5 rounded-full'
                          control='input'
                        />
                        <FormControl
                          name='en_designation'
                          label='Designation'
                          placeholder='Enter designation'
                          className='outline-none w-full h-[2.7rem] border border-[#CFD5E2] px-5 rounded-full'
                          control='input'
                        />
                        <FormControl
                          name='en_bio'
                          label='Summarized Bio'
                          placeholder='Enter a short bio...'
                          className='outline-none w-full h-[8rem] border border-[#CFD5E2] px-5 py-3 rounded-2xl resize-none'
                          control='textarea'
                        />
                      </div>

                      {/* Arabic Fields */}
                      <div className='bg-[#FFF8F5] rounded-2xl p-5 border border-[#F0E2DA]' dir='rtl'>
                        <h3 className='text-primary font-MluvkaBold text-[1rem] mb-4 flex items-center gap-2'>
                          <span className='bg-primary text-white text-xs px-2 py-1 rounded-full'>AR</span>
                          عربي
                        </h3>
                        <FormControl
                          name='ar_name'
                          label='الاسم'
                          placeholder='أدخل اسم المؤلف'
                          className='outline-none w-full h-[2.7rem] border border-[#CFD5E2] px-5 rounded-full text-right'
                          control='input'
                        />
                        <FormControl
                          name='ar_designation'
                          label='المسمى الوظيفي'
                          placeholder='أدخل المسمى الوظيفي'
                          className='outline-none w-full h-[2.7rem] border border-[#CFD5E2] px-5 rounded-full text-right'
                          control='input'
                        />
                        <FormControl
                          name='ar_bio'
                          label='نبذة مختصرة'
                          placeholder='أدخل نبذة مختصرة...'
                          className='outline-none w-full h-[8rem] border border-[#CFD5E2] px-5 py-3 rounded-2xl resize-none text-right'
                          control='textarea'
                        />
                      </div>

                    </div>
                  </div>

                  <ul className='list flex justify-end gap-4 items-center pb-6 px-5'>
                    <li>
                      <SubmitButton
                        props={{
                          class: 'btn bg-secondary text-white uppercase py-3 px-8 rounded-full w-full block submit hover:bg-primary transition-all duration-300',
                          text: 'Update',
                        }}
                        buttonLoading={res.isLoading}
                      />
                    </li>
                  </ul>
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EditAuthor;
